<template lang="pug">
div.container-header.mb-1( v-if="userInfo" )
  div.welcome-data
    person-avatar
    div.welcome-message
      span.text-20-b Привет, {{ returnUserName }} 👋
      span.text-14 Достигай своих целей!
  div.card-container
    div.card
      div.background-card
      img( src="@/assets/app-icon.svg" )
      span.app-name.mt-1.ml-1 KiddieCoin
      div.personal-account
        div.personal-data.mt-2
          span.text-16-b {{ returnUserSurname }}
          span.surname.text-16-b {{ returnUserName }}
          span.text-11 Год рождения {{ returnYearOfBirth }}
      img.squirrel( src="@/assets/cardIcon/kcIcon.svg" )  
    div.balance-container
      span.text-20 Баланс:
      span.text-20-b.ml-6 {{ cardInfo ? cardInfo.cardbalans_pretty : cardInfoTest.balanc }} {{ convertToValueLabel('RUR')}}
    div.bonus-container
      img( src="@/assets/bonus-star.svg" )
      span.ml-2.text-15 Доп.Баллы: {{ cardInfoTest.bonus }}

</template>
<script>
import { mapActions, mapState } from 'vuex';
import PersonAvatar from './Avatar.vue';
export default {
  name: 'CardPanel',

  components: {
    PersonAvatar
  },

  props: {
  },

  data() {
    return {
      cardInfoTest: {
        balanc: 2450,
        bonus: 0
      }
    }
  },

  mounted() {
    if(!this.userInfo) this.loadUserInfo()
    if(!this.cardInfo) this.loadCard()
  },

  computed: {
    ...mapState('user', ['userInfo', 'cardInfo']),

    returnYearOfBirth() {
      let date = this.userInfo.birth_date.split(' ')[0].split('.').reverse().join('-');
      return new Date(date).getFullYear()
    },

    returnUserName() {
      return this.userInfo.fio.split(" ")[1]
    },

    returnUserSurname() {
      return this.userInfo.fio.split(" ")[0]
    }
    
  },

  methods: {
    ...mapActions('user', ['loadUserInfo', 'loadCard'])
  }
}
</script>
<style scoped>
.container-header {
  display: flex;
  flex-direction: column;
}
.welcome-data {
  height: 100%;
  padding: 16px 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.welcome-message {
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  color: #FFFFFF;
  align-items: baseline;

}
.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.card {
  position: relative;
  padding: 12px 0px 0px 12px;
  width: 300px;
  height: 180px;
  background: #FFFFFF;
  border-radius: 20px;
  box-shadow: 0px 4px 4px 0px #00000040;
  display: flex;
  align-items: start;
  flex-direction: column;
}
.card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 300px;
  height: 79px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-size: cover;
  background-image: url('@/assets/card-background.png');
}
.card > * {
  position: relative;
  z-index: 1;
}
.balance-container {
  margin-top: 10px;
  color: #FFFFFF;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.bonus-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #FFFFFF;
}
.app-name {
  color: #FFFFFF;
}
.personal-account {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.personal-data {
  display: flex;
  flex-direction: column;
  margin-left: 4px;
}
.personal-img {
  width: 59px;
  height: 79px;
  background-color: grey;
  border-radius: 5px;
}
.squirrel {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 0;
}
.surname {
  margin-top: -6px;
}
</style>
